import { css } from "@emotion/react"
import { useId } from "react"
import { ValidationErrorMessage } from "../donate/form/types"
import { FieldErrorMessage } from "./FieldErrorMessage"

interface FieldChildrenProps {
  errorId: string
  id: string
  isValid: boolean
}

interface FieldProps {
  alignErrors?: "left" | "right" | "center"
  children: (props: FieldChildrenProps) => React.ReactNode
  errors?: ValidationErrorMessage[]
  label?: string
  onBlur?: () => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function Field({
  children,
  errors,
  alignErrors = "left",
  label,
}: FieldProps) {
  const id = useId()
  const isValid = !(errors && errors.length > 0)
  const errorId = `${id}-error`

  const childrenProps = {
    id,
    isValid,
    errorId,
  }

  return (
    <div className="field">
      {label && <label htmlFor={id}>{label}</label>}
      {children(childrenProps)}
      {!isValid && (
        <FieldErrorMessage
          id={errorId}
          css={css`
            text-align: ${alignErrors};
          `}
        >
          {errors?.[0]}
        </FieldErrorMessage>
      )}
    </div>
  )
}
